import { useEffect, useRef, useState } from "react";

import NoDataMessage from "components/common/NoDataMessage";
import { Button, Typography } from "neetoui";
import { isEmpty, equals } from "ramda";
import { useTranslation } from "react-i18next";
import { useHistoryStore } from "stores/useHistoryStore";

import AlertMessage from "./Alert";
import Item from "./Item";

const History = () => {
  const { t } = useTranslation();
  const { history, selectedTitle, clearAllHistory } = useHistoryStore.pick();
  const itemRefs = useRef({});
  const [shouldShowDeleteAllAlert, setShouldShowDeleteAllAlert] =
    useState(false);

  useEffect(() => {
    if (selectedTitle && itemRefs.current[selectedTitle]) {
      itemRefs.current[selectedTitle].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [selectedTitle]);

  const handleClearHistory = () => {
    clearAllHistory();
    setShouldShowDeleteAllAlert(false);
  };

  return (
    <div className="fixed right-0 top-16 flex h-full w-1/3 flex-col border-l border-gray-300 bg-white">
      <div className="flex w-full items-center justify-between p-4">
        <Typography className="text-center" style="h3" weight="bold">
          {t("title.viewHistory")}
        </Typography>
        <Button
          className="rounded-md bg-white p-2 text-red-700 hover:text-red-700"
          disabled={isEmpty(history)}
          label={t("buttons.clearAll")}
          style="text"
          onClick={() => setShouldShowDeleteAllAlert(true)}
        />
      </div>
      <div className="my-2 flex-1 space-y-2 overflow-y-auto px-4 pb-4">
        {isEmpty(history) ? (
          <NoDataMessage message={t("message.historyIsEmpty")} />
        ) : (
          history.map(title => (
            <div
              key={title}
              ref={element => (itemRefs.current[title] = element)}
            >
              <Item isSelected={equals(title, selectedTitle)} title={title} />
            </div>
          ))
        )}
      </div>
      <AlertMessage
        isOpen={shouldShowDeleteAllAlert}
        message="message.clearAllHistory"
        title="title.clearAllHistory"
        onClose={() => setShouldShowDeleteAllAlert(false)}
        onSubmit={handleClearHistory}
      />
    </div>
  );
};

export default History;
